/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  createStudents({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student/signup", data)
        .then((response) => {
          // commit('SET_STUDENTS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  fetchStudents({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/student")
        .then((response) => {
          commit('SET_STUDENTS', response.data)
          commit('SET_STUDENTS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudent({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/student/"+userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudentLogbokClasses({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/studentLogbokClass", {student_id : userId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchStudentLogbokClassesForPackage({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/studentClassLog", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateStudent({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student/"+data.student_id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateUserStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student/status/"+data.student_id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateTeacherStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/teacher/status/"+data.teacher_id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteStudent({ commit }, studentId) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/admin/studentDelete/"+studentId)
        .then((response) => {
          commit('REMOVE_STUDENT', studentId)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },

  createTeachers({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/teacher/signup", data)
        .then((response) => {
          // commit('SET_STUDENTS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateTeacher({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/teacher/"+data.teacher_id, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  fetchTeachers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/teacher")
        .then((response) => {
          commit('SET_TEACHERS', response.data)
          commit('SET_TEACHERS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTeacher({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/teacher/"+userId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTeacherSignature({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTeacherSignature", {teacher_id : userId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  studentsMonthWiseRegistation({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/monthWise/student")
        .then((response) => {
          var seriesY = [];
          var seriesX = [];
          for (const entry of response.data){
            seriesX.push(entry.month_text+" "+entry.year)
            seriesY.push(entry.students)
          }

          commit('SET_STUDENTS_REGISTATION_X', seriesX)
          commit('SET_STUDENTS_REGISTATION_Y', seriesY)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  adminViewTeacherLogbogClasses({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminViewTeacherLogbogClasses", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  uploadTeacherSignatureImage({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/uploadTeacherSignature", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteTeacher({ commit }, teacherId) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/admin/teacherDelete/"+teacherId)
        .then((response) => {
          commit('REMOVE_TEACHER', teacherId)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },


  recoverPassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/profile", data)
        .then((response) => {
          commit('UPDATE_USER_INFO', response.data.user, {root: true})
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateProfile({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/profile", data)
        .then((response) => {
          commit('UPDATE_USER_INFO', response.data.user, {root: true})
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updatePassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/changePassword", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateClub({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/club", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
}
